import React from "react";
//import Sidebar from "../components/navigation/navigation";
import h from "../styles.module.css";
import Detail from "../components/detail/detail";

export default function MainDetail() {
  //const [toggle, setToggle] = useState(true);
  // const wrapper = {
  //   position: "absolute",
  //   top: "0",
  //   left: "300px",
  //   width: "calc(100% - 300px)",
  //   height: "100%",
  //   paddingLeft: "2.5%",
  //   paddingRight: "2.5%",
  //   msOverflowStyle: "none",
  //   transition: "width 200ms, left 200ms, right 200ms",
  // };

  const wrapperActive = {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    paddingLeft: "2.5%",
    paddingRight: "2.5%",
    msOverflowStyle: "none",
    transition: "width 200ms, left 200ms, right 200ms",
  };
  return (
    <div className={h.container}>
      {/* <button className={h.burguer} onClick={() => setToggle(!toggle)}></button> */}
      {/* <Sidebar toggle={toggle} /> */}
      {/* </div><div style={toggle ? wrapper : wrapperActive}> */}
      <div style={wrapperActive}>
        <Detail />
      </div>
    </div>
  );
}
